import { Box, Divider, Paper, Typography } from "@mui/material";
import GoogleLoginButton from "./GoogleLoginButton";
import SignUpForm from "./SignUpForm";
import LoginForm from "./LoginForm";
import { useState } from "react";

const Login = () => {
    const [activeForm, setActiveForm] = useState('signin');
    const handleActiveFormChange = (form: string) => {
        setActiveForm(form);
    };
    return <Paper  sx={{ maxWidth: 400, display: 'flex', flexDirection: 'column', alignItems: 'center',
      borderRadius: '6px',
      justifyContent: 'center',
      boxShadow: "0px 2px 1px -1px rgba(255, 255, 255, 1),0px 1px 1px 0px rgba(255, 255, 255, 1),0px 1px 3px 0px rgba(255, 255, 255, 1)",
     }} className="login-component">
        <Paper elevation={3} sx={{ p: 4, maxWidth: 400, mx: "auto" }}>
         <Typography variant="h6" sx={{alignSelf: 'self-start'}}>Welcome back!</Typography>
         <Typography variant="body2" sx={{alignSelf: 'self-start'}}>Sing in to access your dashboard and continue your work</Typography>
        
        <Box>
          {activeForm === 'signin' && <LoginForm />}
          {activeForm === 'signup' && <SignUpForm handleActiveFormChange={handleActiveFormChange} />}
        </Box>
        <Divider sx={{ width: '100%', alignSelf: 'center', margin: '1rem 0' }}>Or</Divider>
        <center><GoogleLoginButton /></center>
        <Box sx={{ textAlign: 'center', fontSize: '0.9em' }}>
          <p>Don't have an account? 
            <Typography variant="button" onClick={() => handleActiveFormChange('signup')} style={{ color: 'var(--primary-color)', textDecoration: 'none' }}>
                Sign Up
            </Typography>
        </p>
        </Box>
        </Paper>
    </Paper>;
}

export default Login;